import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AGENCY_ALLOWED_PREFIXES = [
  '/crew',
  '/account-settings',
  '/profile',
  '/login',
];

function isAgencyAllowedPath(pathname: string): boolean {
  if (pathname === '/crew' || pathname === '/crew/') return true;
  if (pathname === '/crew/list' || pathname.startsWith('/crew/list/')) return true;
  if (pathname === '/crew/new') return true;
  // File / edit / print only — bare `/crew/:id` is the AI dashboard (office-only).
  if (/^\/crew\/\d+\/(edit|file(\/print)?)$/.test(pathname)) return true;
  if (pathname.startsWith('/account-settings') || pathname.startsWith('/profile')) return true;
  if (pathname === '/notifications' || pathname.startsWith('/notifications/')) return true;
  return false;
}

/** Redirect manning-agent users away from office routes outside Crew Pool / List / File. */
const ManningAgentRouteGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const isAgency = String(user?.typeLocation ?? '').toUpperCase() === 'MANNING_AGENT';

  if (isLoading) return <>{children}</>;
  if (!isAgency) return <>{children}</>;

  const dashMatch = location.pathname.match(/^\/crew\/(\d+)\/?$/);
  if (dashMatch) {
    return <Navigate to={`/crew/${dashMatch[1]}/file`} replace />;
  }

  if (!isAgencyAllowedPath(location.pathname)) {
    return <Navigate to="/crew" replace />;
  }

  return <>{children}</>;
};

export default ManningAgentRouteGuard;
export { isAgencyAllowedPath, AGENCY_ALLOWED_PREFIXES };
